import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { LicenseInfo } from '@mui/x-data-grid-pro';

LicenseInfo.setLicenseKey(
  // NUOVA LICENZA 28-09-2026
  // '9509e5a29088ce44506b7f25bc9ee953Tz0xMzM0MDMsRT0xODI2MDYzOTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==',
  'ffbd306c19e1f999029f99b546cf472fT1JERVI6MzYzNzcsRVhQSVJZPTE2NzQzMzcyNDYwMDAsS0VZVkVSU0lPTj0x',
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
